/* eslint-disable no-param-reassign */
/* eslint-disable no-shadow */
import Vue from 'vue'

const state = {
  arquivos: [],
}

// getters
const getters = {
  arquivos: state_ => state_.arquivos,
}

const actions = {
  setArquivos({ commit }, arquivos) {
    commit('SET_ARQUIVOS', arquivos)
  },
  addAquivoList({ commit }, arquivo) {
    commit('ADD_ARQUIVO_LIST', arquivo)
  },
  concat_lists({ commit }, arquivos) {
    commit('CONCAT_LISTS', arquivos)
  },
  delete({ commit }) {
    commit('INITIAL')
  },
  removeItem({ commit }, index) {
    commit('REMOVE_ITEM', index)
  },
}

// mutations
const mutations = {
  INITIAL(state_) {
    state_.arquivos = []
  },
  SET_ARQUIVOS(state_, arquivos) {
    Vue.set(state_, 'arquivos', arquivos)
  },
  ADD_ARQUIVO_LIST(state_, arquivo) {
    state_.arquivos.forEach((item, index) => {
      if (item.indetificado === arquivo.indetificado) {
        Vue.set(state_.arquivos, index, arquivo)
      }
    })
  },
  CONCAT_LISTS(state_, arquivos) {
    state_.arquivos = state_.arquivos.concat(arquivos)
  },
  REMOVE_ITEM(state_, index) {
    state_.arquivos.splice(index, 1)
  },

}

export default {
  namespaced: true,
  getters,
  actions,
  mutations,
  state: () => state,
}
